import React, { Component } from "react";
import PropTypes from "prop-types";
import { Body, Footer } from "MODULES/shared/components/Modal";

export default class LineItemsForm extends Component {
  static propTypes = {
    lineItems: PropTypes.arrayOf(PropTypes.number),
    close: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    addLineItems: PropTypes.func
  };

  state = {
    selectedLineItems: []
  };

  onItemSelected = lineItem => {
    if (lineItem.id === null) {
      return;
    }

    const { selectedLineItems } = this.state;
    const array = [...selectedLineItems];
    const index = array.indexOf(lineItem);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ selectedLineItems: array });
    } else {
      this.setState({
        selectedLineItems: selectedLineItems.concat([lineItem])
      });
    }
  };

  renderRow = (lineItem, i) => (
    <tr key={i}>
      <td style={{ backgroundColor: "#383838" }}>{i + 1}</td>
      <td style={{ marginBottom: "6px" }}>
        <input
          name="line_items"
          type="checkbox"
          onChange={() => this.onItemSelected(lineItem)}
        />
      </td>
      <td>{lineItem.part.part_number}</td>
      <td>{lineItem.serial_number}</td>
    </tr>
  );

  render() {
    const { close, handleSubmit, addLineItems, lineItems } = this.props;
    const { selectedLineItems } = this.state;
    return (
      <form onSubmit={handleSubmit}>
        <Body>
          <table className="table table-striped table-hover table-numbered">
            <thead>
              <tr>
                <th />
                <th />
                <th>Part Number</th>
                <th>Serial Number</th>
              </tr>
            </thead>
            <tbody>
              {lineItems.map((inv, idx) => this.renderRow(inv, idx))}
            </tbody>
          </table>
        </Body>
        <Footer>
          <button type="button" className="btn btn-default" onClick={close}>
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-success"
            onClick={e => {
              e.preventDefault();
              addLineItems(selectedLineItems);
            }}
          >
            Create Commercial Invoice
          </button>
        </Footer>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/CommercialInvoice/Form/FormSections/LineItemsForm.jsx